import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Header from "../components/Header";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

function Help() {
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"help"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <h2>{t("help.title")}</h2>
              </div>
              <div className="content-details">
                <h3>{t("help.concepts_title")}</h3>
                <p>{t("help.concepts_content_p1")}</p>
                <p>{t("help.concepts_content_p2")}</p>
                <p>
                  {t("help.concepts_content_p3_1")} <br />
                  {t("help.concepts_content_p3_2")} <br />
                  {t("help.concepts_content_p3_3")} <br />
                  {t("help.concepts_content_p3_4")}
                </p>

                <h3>{t("help.sms_campaign_title")}</h3>
                <ol>
                  <li>
                    <strong>{t("help.campaign_location")}</strong> -
                    {t("help.campaign_location_introduce")}
                  </li>
                  <li>
                    <strong>{t("help.campaign_import")}</strong> -{" "}
                    {t("help.campaign_import_introduce")}
                  </li>
                  <li>
                    <strong>{t("help.campaign_create")}</strong> -{" "}
                    {t("help.campaign_create_introduce")}
                  </li>
                </ol>

                <h3>{t("help.campaign_status_title")}</h3>
                <ul>
                  <li>
                    <strong>{t("help.campaign_status_pending")}</strong> -{" "}
                    {t("help.campaign_status_pending_introduce")}
                  </li>
                  <li>
                    <strong>{t("help.campaign_status_active")}</strong> -{" "}
                    {t("help.campaign_status_active_introduce")}
                  </li>
                  <li>
                    <strong>{t("help.campaign_status_complete")}</strong> -{" "}
                    {t("help.campaign_status_complete_introduce")}
                  </li>
                </ul>

                <h3>{t("help.system_introduce_title")}</h3>
                <p>{t("help.system_introduce_content")}</p>

                <h3>{t("help.csv_template_title")}</h3>
                <p>
                  {t("help.csv_template_promt_start")}{" "}
                  <a href="./template.csv">
                    {t("help.csv_template_promt_end")}
                  </a>
                </p>

                <h3>{t("help.contact_title")}</h3>
                <p>{t("help.contact_promt")} </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Help;
